import axios from "axios";

const API_URL = import.meta.env.VITE_API_URL;

const PointLayerService = {
    getById: async (id) => axios.get(API_URL + `/pointLayer/${id}`).then(({data}) => data).catch((err) => { throw err }),
    getIcons: async () => axios.get(API_URL + "/pointLayer/get/icons").then(({data}) => data).catch((err) => { throw err }),
    sendKmz: async (formData) => axios.post(API_URL + "/pointLayer/sendKmz", formData).then(({data}) => data).catch((err) => { throw err }),
    save: async (formData) => axios.post(API_URL + "/pointLayer", formData).then(({data}) => data).catch((err) => { throw err }),
    remove: async (id) => axios.delete(API_URL + `/pointLayer/${id}`).then(({data}) => data).catch((err) => {throw err}),
    list: async () =>  axios.get(API_URL + `/pointLayer-list`).then(({data}) => data).catch((err) => { throw err }),
}

export default PointLayerService;